import { formatTrimmedDecimal } from '@/helpers/finance';

const AMOUNT_DISPLAY_DECIMAL_PLACES = 2;

/**
 * Formats an approvals money value with its currency code, e.g. `1250.5 → "1250.5 USD"`.
 * Currency-less values (should not happen for real amounts) render the bare number.
 */
export const formatApprovalMoney = (amount: number, currencyCode: string | null): string => {
  const formatted = formatTrimmedDecimal(amount, AMOUNT_DISPLAY_DECIMAL_PLACES);
  return currencyCode ? `${formatted} ${currencyCode}` : formatted;
};
